import { API_BASE_URL, testSessionId } from "./api";
import { User } from "../types/User";
import { Post } from "../types/Post";

export const getUser = async (username: string): Promise<User> => {
  const response = await fetch(`${API_BASE_URL}/users/${username}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${testSessionId}`,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch user data.");
  }

  return response.json();
};

export const followUser = async (username: string): Promise<void> => {
  const response = await fetch(`${API_BASE_URL}/users/${username}/follow`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${testSessionId}`,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to follow user.");
  }
};

export const unfollowUser = async (username: string): Promise<void> => {
  const response = await fetch(`${API_BASE_URL}/users/${username}/follow`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${testSessionId}`,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to unfollow user.");
  }
};

export const getUserPosts = async (username: string): Promise<Post[]> => {
  const response = await fetch(`${API_BASE_URL}/users/${username}/posts`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${testSessionId}`,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch user posts.");
  }

  return response.json();
};
